import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useModal } from "../contexts/ModalContext";
import { BaseUrl } from "../helper/BaseUrl";
import { fetchJson } from "../helper/fetchJson";
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);


  // Mobile
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setActiveMenu(null);
    setActiveSubMenu(null);
  };
  const handleMenuToggle = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
    setActiveSubMenu(null);
  };

  const handleSubMenuToggle = (submenu) => {
    setActiveSubMenu(activeSubMenu === submenu ? null : submenu);
  };

  const { openQueryModal } = useModal();
  const [allData, setAllData] = useState([]);

  const location = useLocation();

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const handleLinkClick = useCallback(() => {
    setMenuOpen(false);
  }, []);


  // API Calling
  const fetcher = async () => {
    try {
      const result = await fetchJson(`${BaseUrl}/api/dynamic-pages`);
      if (result.dynamic_pages === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.dynamic_pages);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])
  return (
    <>
      <div className="header-main">
        <header className="header">
          <div className="container">
            <div className="row align-items-center header-reverse">
              <div className="col-4 col-md-3 col-lg-4">
                <div className="header-logo">
                  <Link to="/">
                    <img src="/assets/images/header-logo.webp" width="140" height="51" alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-8 col-md-9 col-lg-8  col-static" >
                <div className="header-menu">
                  <div className="header-menu-items">
                    <ul >
                      <li className="child-item">
                        <Link className="item-link" >  Solutions  </Link>
                        <div className="nav-dropdown  extrawide">
                          <div className="nav-dropdown-label">Solutions </div>
                          <ul className="solution-child">
                            <li>
                              <div className="item">
                                <Link to="/transportation-management-services-tms" >
                                  <label>TMS Integration</label>
                                  <p>Centralize logistics planning, execution, and tracking across operations.</p>
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="item">
                                <Link to="/shipment-tracking">
                                  <label>Shipment Tracking</label>
                                  <p>Track shipments in real time with complete end-to-end visibility.</p>
                                </Link>
                              </div>
                            </li>
                            <li>

                              <div className="item">
                                <Link to="/warehouse-management-system-wms" > <label>Warehouse Management </label>
                                  <p>Manage vehicles, drivers, and performance with real-time visibility.</p>
                                </Link>
                              </div>
                            </li>
                            <li>

                              <div className="item">
                                <Link to="/first-mile-logistics" > <label>First Mile Pickup</label>
                                  <p>Streamline pickups and origin operations for faster dispatch efficiency.</p>
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="item">
                                <Link to="/middle-mile-logistics" > <label>Mid Mile</label>
                                  <p>Ensure smooth transit operations with better coordination and visibility.</p>
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="item">
                                <Link to="/last-mile-delivery-logistics"> <label>Last Mile Delivery</label>
                                  <p>Improve delivery accuracy and speed for better customer satisfaction.</p>
                                </Link>
                              </div>
                            </li>
                            <li className="child-dropdown">
                              <div className="item">
                                <Link to="/route-optimization-and-planning" >
                                  <label>Route Optimization</label>
                                  <p>Optimize routes to reduce costs <br /> and improve delivery efficiency.</p>
                                </Link>
                              </div>

                              <div className="route-subchild">
                                <div className="border-top"></div>
                                <ul>
                                  {allData?.map((loc, index) => (
                                    <li key={index}><Link to={loc?.category_slug + "/" + loc?.slug}>{loc?.page_name}</Link></li>
                                  ))}
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="child-item">
                        <Link className="item-link" >   Industries </Link>
                        <div className="nav-dropdown  wide">
                          <div className="nav-dropdown-label">Industries</div>
                          <ul className="industries-child">
                            <li><Link to="/post-parcel-carriers-software" >Post & Parcel Carriers</Link></li>
                            <li><Link to="/retail-quick-commerce-solutions">Retail - Quick Commerce</Link></li>
                            <li><Link to="/freight-management-solutions" >Freight <br /> Forwarders</Link></li>
                            <li><Link to="/process-manufacturing-logistics-solutions" >Process Manufacturing</Link></li>
                            <li><Link to="/grocery-delivery-management-software" >Groceries & Quick Commerce</Link></li>
                            <li><Link to="/automotive-supply-chain-platform">Automotive Industry</Link></li>
                            <li><Link to="/consumer-goods-logistics-platform" >Consumer Goods</Link></li>
                          </ul>
                        </div>
                      </li>

                     


                      <li className="child-item">
                        <Link className="item-link" >  Resources  </Link>
                        <div className="nav-dropdown">
                          <ul>
                            <li><Link to="/blogs">Blogs</Link></li>
                            <li><Link to="/case-study">Case Studies</Link></li>
                            <li><Link to="/integration">Integrations</Link></li>
                             <li><Link to="/media">Media</Link></li>
                          </ul>
                        </div>
                      </li>

                       <li className="child-item">
                        <Link className="item-link" to="/about-us" >  Company  </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="header-btn">
                    <Link className="theme-btn" onClick={openQueryModal}>
                      <span>Request a Demo</span>
                    </Link>
                  </div>
                  <div className="mobile-trigger" onClick={toggleMenu}  >
                    <div className="menu-line icon-top"></div>
                    <div className="menu-line icon-center"></div>
                    <div className="menu-line icon-bottom"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>




      {/* mobile */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="menu-header" onClick={closeMenu}>  <button ><span>✕</span></button>  </div>
        <ul className="menu-toggel-items">
          <li >
            <Link className="item-link" onClick={() => handleMenuToggle("solutions")}>  Solutions
              <label>{activeMenu === "solutions" ? "−" : "+"}</label>
            </Link>

            <div className="mobile-dropdown">
              <ul className={activeMenu === "solutions" ? "mobile-submenu visible" : "mobile-submenu"}>
                <li><Link to="/warehouse-management-system-wms" onClick={handleLinkClick} >Warehouse Management</Link></li>
                <li><Link onClick={() => handleSubMenuToggle("route")}>Route Optimization   <label>{activeSubMenu === "route" ? "−" : "+"}</label> </Link>
                  <div className="mobile-dropdown subdropdown">
                    <ul className={activeSubMenu === "route" ? "mobile-submenu visible" : "mobile-submenu"}>
                      <li><Link to="/route-optimization-and-planning" onClick={handleLinkClick}>Route Optimization</Link></li>
                      {allData?.map((loc, index) => (
                        <li key={index} ><Link to={loc?.category_slug + "/" + loc?.slug} onClick={handleLinkClick}>{loc?.page_name}</Link></li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li><Link to="/first-mile-logistics" onClick={handleLinkClick}>First Mile Pickup</Link></li>
                <li><Link to="/middle-mile-logistics" onClick={handleLinkClick} >Mid Mile</Link></li>
                <li><Link to="/last-mile-delivery-logistics" onClick={handleLinkClick} >Last Mile Delivery</Link></li>
                <li><Link to="/transportation-management-services-tms" onClick={handleLinkClick} >TMS Integration</Link></li>
                <li><Link to="/shipment-tracking" onClick={handleLinkClick} >Shipment Tracking</Link></li>
              </ul>
            </div>
          </li>
          <li >
            <Link className="item-link" onClick={() => handleMenuToggle("industries")}> Industries
              <label>{activeMenu === "industries" ? "−" : "+"}</label>
            </Link>
            <div className="mobile-dropdown">
              <ul className={activeMenu === "industries" ? "mobile-submenu visible" : "mobile-submenu"} >
                <li><Link to="/post-parcel-carriers-software" onClick={handleLinkClick} >Post & Parcel Carriers</Link></li>
                <li><Link to="/retail-quick-commerce-solutions" onClick={handleLinkClick}>Retail - Quick Commerce</Link></li>
                <li><Link to="/freight-management-solutions" onClick={handleLinkClick} >Freight Forwarders</Link></li>
                <li><Link to="/process-manufacturing-logistics-solutions" onClick={handleLinkClick} >Process Manufacturing</Link></li>
                <li><Link to="/grocery-delivery-management-software" onClick={handleLinkClick} >Groceries & Quick Commerce</Link></li>
                <li><Link to="/automotive-supply-chain-platform" onClick={handleLinkClick}>Automotive Industry</Link></li>
                <li><Link to="/consumer-goods-logistics-platform" onClick={handleLinkClick} >Consumer Goods</Link></li>
              </ul>
            </div>
          </li>
          <li >
            <Link className="item-link" onClick={() => handleMenuToggle("resources")} >  Resources
              <label>{activeMenu === "resources" ? "−" : "+"}</label>
            </Link>
            <div className="mobile-dropdown">
              <ul className={activeMenu === "resources" ? "mobile-submenu visible" : "mobile-submenu"}>
                <li><Link to="/blogs" onClick={handleLinkClick} >Blogs</Link></li>
                <li><Link to="/case-study" onClick={handleLinkClick} >Case Studies</Link></li>
                <li><Link to="/integration" onClick={handleLinkClick} >Integrations</Link></li>
                      <li><Link to="/media"  onClick={handleLinkClick}>Media</Link></li>
              </ul>
            </div>
          </li>
            <li >
            <Link className="item-link"to="/about-us" onClick={() => handleMenuToggle("company")} >  Company
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
